

<app-reset-password-page
  [error]="error$ | async"
  [submitting]="submitting$ | async"
  [isResetLinkValidationCompleted]="isResetLinkValidationCompleted$ | async"
  [isResetLinkValid]="isResetLinkValid$ | async"
  (onSubmit)="doSubmit($event)">
</app-reset-password-page>
